module.exports = __webpack_public_path__ + "img/amoureux.76decd3e.png";